import { render, staticRenderFns } from "./ChooseUs.vue?vue&type=template&id=507843ae&scoped=true"
import script from "./ChooseUs.vue?vue&type=script&lang=js"
export * from "./ChooseUs.vue?vue&type=script&lang=js"
import style0 from "./ChooseUs.vue?vue&type=style&index=0&id=507843ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507843ae",
  null
  
)

export default component.exports